import service from '@/utils/request'

// 列表
export function actCultivateList(data) {
    return service({
        url: '/service/admin/actCultivateList',
        method: 'get',
        params: data
    })
}

// 详情
export function actCultivateElem(data) {
    return service({
        url: '/service/admin/actCultivateElem',
        method: 'get',
        params: data
    })
}

// 新增
export function actCultivateAdd(data) {
    return service({
        url: '/service/admin/actCultivateAdd',
        method: 'post',
        data
    })
}

// 编辑
export function actCultivateEdit(data) {
    return service({
        url: '/service/admin/actCultivateEdit',
        method: 'post',
        data
    })
}

// 删除
export function actCultivateDelete(data) {
    return service({
        url: '/service/admin/actCultivateDelete',
        method: 'post',
        data
    })
}
